module.exports = __webpack_public_path__ + "img/63.a2560ab7.jpg";